import { ItemTrackingContentType } from '../models/public-tracking.model';

export class PublicTrackingItemLoad {
  public static readonly type = '[Public Tracking] Load';
  constructor(
    public payload: {
      itemId: string;
      zipCode?: string;
      trackingContentType?: ItemTrackingContentType | string;
      sapId?: string;
    },
  ) {}
}

export class PublicTrackingInitialState {
  public static readonly type = '[Public Tracking] Set initial state';
}
